import React from 'react';

import {AppMode} from './app-types';
import {withAppEnv, addAssembledAppEnv} from './app-env';
import AppConfig from './app-config';
import AppStateController from './app-state-controller';
import AppInterfaceFactory from './interface/app-interface-factory';
import {oeInterfaceManager} from '../react-oe/oe-interface';
import OEInterfaceAdapter from '../react-oe/oe-interface-adapter';
import {OEAppInitResultCode, OEChangeTargetResult} from '../react-oe/oe-types';
import OEColorHelper from '../lib/color/oe-color-helper';
import OEStyleSheetTool from '../lib/tools/oe-style-sheet-tool';
import OECapBar from '../components/bars/cap/oe-cap-bar';
import OEModule from '../components/oe-module';
import {OETarget} from '../react-oe/oe-target';
import {OEStatusType} from '../react-oe/oe-surface';
import OELicensingApp from '../components/licensing-start/oe-licensing-app';
import OEProductIdTargetMap from '../react-oe/oe-product-id-target-map';
import {OELogoView} from '../components/elements/oe-logo-view';
import OENotification from '../lib/notification/oe-notification';
import OEAnalyticsTracker from '../lib/tools/analytics/oe-analytics-tracker';

export class App extends React.PureComponent {

    constructor(props) {
        super(props);

        this.moduleId = OEModule.defaultProps.moduleId;

        this.oe = oeInterfaceManager.getInterface(this.moduleId);

        this.props.appEnv.component.app = this;

        this.config = new AppConfig({initial: true});

        this.state = {
            mode: this.config.startAppMode
        };

        this.onColorModelChanged = this.onColorModelChanged.bind(this);

        this.onBgColorChanged = this.onBgColorChanged.bind(this);

        this.onStatusChanged = this.onStatusChanged.bind(this);

        this.onShouldPlayProduct = this.onShouldPlayProduct.bind(this);

        this.setupPageScrollForMode(config.startAppMode);
        this.onConfigSet();
    }

    changeMode(mode)    {
        this.setState({mode: mode});
        this.setupPageScrollForMode(mode);
    }

    setConfig(config)   {
        this.config = config;
        this.onConfigSet();
    }

    changeTarget(target, callback)    {
        let appConfig = new AppConfig({target: target});

        if(this.state.mode !== AppMode.play)    {
            let changed = this.config.target != target;
            this.setConfig(appConfig);
            if(callback)    callback(new OEChangeTargetResult(OEAppInitResultCode.ok, changed, target), this.oe);
            return true;
        }

        if(appConfig.resourceTarget !== this.config.resourceTarget) {   // resource target changes are handled by core iframe component update in OESurface
            let appComponent = this.props.appEnv.component;
            if(appComponent && appComponent.uiLayer) appComponent.uiLayer.closeAllPopovers();
            
            if(callback)    this.oe.registerTargetChangeCallback(callback, target);
            this.setConfig(appConfig);
            return;
        }

        if(!this.oe.changeTarget(target, appConfig.module, (result, oe) => {
            if(callback)    callback(result, oe);
        })) return false;

        let appComponent = this.props.appEnv.component;
        if(appComponent && appComponent.uiLayer) appComponent.uiLayer.closeAllPopovers();
        this.setConfig(appConfig);

        return true;
    }

    reset(animated = true, duration = 0.5, flags)   {
        if(!this.oe.isReady() || !this.oe.sharedInterface.getUIControllerApp().getUIEnabled())  return false;
        let appComponent = this.props.appEnv.component;
        if(appComponent && appComponent.uiLayer) appComponent.uiLayer.closeAllPopovers();
        this.oe.sharedInterface.getUIControllerApp().reset(animated, duration, flags);
        return true;
    }

    componentDidMount()    {
        OEStyleSheetTool.updateColorStyle(null, null, true);
        OEColorHelper.registerModelChangeListener(this.onColorModelChanged);
    }

    componentWillUnmount()    {
        OEColorHelper.unregisterModelChangeListener(this.onColorModelChanged);
    }

    componentWillUpdate(nextProps, nextState)   {
        if(this.state.mode !== nextState.mode && nextState.mode === AppMode.start)  {
            if(this.props.appEnv.component.appStateController)  this.props.appEnv.component.appStateController.setFullscreen(false);
        }
    }

    onConnect()   {
        this.onBgColorChanged();
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.bgColorChanged, this.onBgColorChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.vignetteStrengthChanged, this.onBgColorChanged);
    }

    onRelease()   {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.bgColorChanged, this.onBgColorChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.vignetteStrengthChanged, this.onBgColorChanged);
    }

    onColorModelChanged()   {
        OEStyleSheetTool.updateColorStyle(null, null, true);
        if(this.props.appEnv.component) this.props.appEnv.component.uiLayer.notificationCenter.post(OENotification.colorModelChanged);
    }

    onBgColorChanged()  {
        if(!this.oe.isReady()) return;

        let brightness = this.oe.sharedInterface.getUIControllerColorTheme().getBackgroundColorBrightness();
        let borderBrightness = this.oe.sharedInterface.getUIControllerColorTheme().getBackgroundBorderBrightness();

        OEStyleSheetTool.updateColorStyle(brightness, borderBrightness);
    }

    setupPageScrollForMode(mode)    {
        var m = mode || this.state.mode;

        if(m === AppMode.start) {
            $('html').removeClass('disable-page-scrolling'); $('body').removeClass('disable-page-scrolling');
        } else {
            if(!$('html').hasClass('disable-page-scrolling'))    $('html').addClass('disable-page-scrolling');
            if(!$('body').hasClass('disable-page-scrolling'))    $('body').addClass('disable-page-scrolling');
        }
    }

    onConfigSet()   {
        OEColorHelper.updateForConfig(this.config);
        OEStyleSheetTool.updateForConfig(this.config);
        this.props.appEnv.setConfig(this.config);
    }

    onStatusChanged(status) {
        if(status.type !== OEStatusType.initialized)    {
            OEStyleSheetTool.updateColorStyle();
        }
    }

    renderStartMode()   {
        return (
            <OELicensingApp
                appComponent={this.props.appEnv.component}
                config={this.props.appEnv.config.licensingAppConfig}
                onShouldPlayProduct={this.onShouldPlayProduct}
            />
        );
    }

    renderPlayMode()    {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.moduleId} receiver={this}/>

                <AppStateController moduleId={this.moduleId}/>

                <AppInterfaceFactory moduleId={this.moduleId}/>

                <div className={'app-container' + (typeof(this.props.appEnv.config.target) === 'string' ? ' target-' + this.props.appEnv.config.target : '') + (typeof(this.props.appEnv.config.className) === 'string' ? ' ' + this.props.appEnv.config.className : '')}>
                    <OECapBar moduleId={this.moduleId} opaque={true}/>

                    <OEModule
                        moduleId={this.moduleId}
                        onStatusChanged={this.onStatusChanged}
                    />

                    <OELogoView moduleId={this.moduleId} className="company-logo" config={this.props.appEnv.config.logo}/>
                </div>
            </React.Fragment>
        );
    }

    render() {
        return (
            <React.Fragment>

                <OEAnalyticsTracker moduleId={this.moduleId}/>

                {this.state.mode === AppMode.start ? this.renderStartMode() : this.renderPlayMode()}

            </React.Fragment>
        );
    }

    onShouldPlayProduct(id)   {
        let target = OEProductIdTargetMap.targetFor(id);
        if(typeof(target) !== 'string' || target === OETarget.void)    return;

        this.changeTarget(target);
        this.changeMode(AppMode.play);
    }
}

export default withAppEnv(addAssembledAppEnv(App));
  